// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3M_5A","right":"styles_right__2qUWB"};